module.exports = __webpack_public_path__ + "static/media/Mask Group 13.538e14fa.svg";